
import React, { useEffect, useRef } from "react";
import About from "./About";
import Content1 from "./addingcontent/Content1";
import Contet2Visssion from "./addingcontent/Contet2Visssion";
import Content3Services from "./Content3Services";
import Leadership from "./Leadership";
import Contact from "./Contact";

const ScrollSections = () => {
  const sectionRefs = useRef([]);

  // Scroll to the section when URL hash changes
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Get the section ID
      const section = document.getElementById(hash);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    };

    // Listen for hash change in the URL
    window.addEventListener("hashchange", handleHashChange);

    // Scroll to the section if hash exists on page load
    handleHashChange();

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const sectionIds = [
    "home",
    "whyus",
    "vissionandmission",
    "ourservices",
    "leadership",
    "contact",
  ];

  return (
    <div>
      {[
        <About />,
        <Content1 />,
        <Contet2Visssion />,
        <Content3Services />,
        <Leadership />,
        <Contact />,
      ].map((Component, index) => (
        <section
          key={index}
          id={sectionIds[index]} // Assigning IDs dynamically
          ref={(el) => (sectionRefs.current[index] = el)}
        >
          {Component}
        </section>
      ))}
    </div>
  );
};

export default ScrollSections;

